import { render, staticRenderFns } from "./CommonErrorAlerts.vue?vue&type=template&id=3b64d146&functional=true&"
import script from "./CommonErrorAlerts.vue?vue&type=script&lang=js&"
export * from "./CommonErrorAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports